exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-portal-target .dropdown[data-v-e027bc48]{display:inline-block;width:25%}", ""]);

// exports
